import {FC} from 'react'
import Select from 'react-select'
import {difference, uniq} from 'lodash'
import {useController, useFormContext} from 'react-hook-form'
import styles from './GroupsSelectBox.scss'

interface Option {
  value: string
  label: string
  parentValue?: string
}

interface GroupsSelectBoxProps {
  name: string
  options: Option[]
}

export const GroupsSelectBox: FC<GroupsSelectBoxProps> = ({name, options}) => {
  const {control} = useFormContext()
  const {field} = useController({name, control})
  return (
    <div className={styles.groupsSelectBox}>
      <Select
        multi
        options={options}
        closeOnSelect={false}
        placeholder="グループ選択"
        name={name}
        value={field.value?.map((v: string) => options.find((o) => o.value === v)) || []}
        noResultsText="グループがありません"
        onChange={(value) => {
          const values = addChildrenWhenParentClicked(options, field.value, value?.map((v: Option) => v.value) || [])
          field.onChange(values)
          field.onBlur()
        }}
      />
    </div>
  )
}

const getOptionChildren = function* (options: Option[], currentValue: string): Generator<string> {
  for (const option of options) {
    if (option.parentValue == currentValue && currentValue !== 'null') {
      yield option.value
      yield* getOptionChildren(options, option.value)
    }
  }
}

const addChildrenWhenParentClicked = (options: Option[], prevValues: string[], currentValues: string[]): string[] => {
  const [added] = difference(currentValues, prevValues)
  if (added) {
    return uniq([...currentValues, ...getOptionChildren(options, added)])
  } else {
    return currentValues
  }
}
